import React from "react";
import Container from "react-bootstrap/Container";
function Contact() {
  return (
    <Container className="contact">
      <h5>
        Email us at info@theroofersofmd.com
        <br></br>
        or call us at (443-569-1511)
      </h5>
    </Container>
  );
}

export default Contact;
